import { CustomProvider, FinalValueResolver, ValueResolver } from '@odinjs/odin';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { isContentfulString, scopedErrorMessage } from '@philips-internal/oswald-ui-utils';
import { MetadataTraverser } from './metadata-traverser.js';
function fragmentCustomProviderError(message) {
    return new Error(`[FragmentCustomProvider]: ${message}`);
}
/**
 * Custom DI Provider for Engine resources.
 * It provides the core services, and components APIs.
 */
class FragmentCustomProvider extends CustomProvider {
    constructor(args) {
        super();
        this.context = args.dataContext;
        this.fragment = args.fragment;
        this.submittableFragmentContext = args.submittableFragmentContext;
        this.metadataTraverser = new MetadataTraverser(args.fragment.getMetadata());
    }
    resolve(identifier) {
        if (identifier === ContextType.DATA) {
            return this.createDataContextResolver();
        }
        if (identifier === ContextType.SUBMITTABLE_FRAGMENT) {
            return this.createSubmittableFragmentContextResolver();
        }
        const uuid = this.metadataTraverser.getUuid(identifier);
        if (isContentfulString(uuid)) {
            return new ValueResolver(() => {
                const component = this.fragment.getChild(uuid);
                if (component) {
                    return component.getAPI();
                }
                scopedErrorMessage('FragmentCustomProvider', 'Trying to access not rendered component API.');
                /**
                 * Returning as a empty object to avoid crashing the editor,
                 * since a error boundary is not effective because the engine renderer is async
                 */
                return {};
            });
        }
        return super.resolve(identifier);
    }
    createDataContextResolver() {
        return new FinalValueResolver(() => {
            return this.context;
        });
    }
    createSubmittableFragmentContextResolver() {
        return new FinalValueResolver(() => {
            if (this.submittableFragmentContext) {
                return this.submittableFragmentContext;
            }
            throw fragmentCustomProviderError('SubmittableFragmentContext is only available on Submittable fragments.');
        });
    }
}
export { FragmentCustomProvider, };
//# sourceMappingURL=fragment-custom-provider.js.map